import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryDropdown from "./components/CategoryDropdown";
import CategoryGrid from "./components/CategoryGrid";
import ContentSections from "./components/ContentSections";
import ArticleCards from "./components/ArticleCards";
import ArticleCTA from "./components/ArticleCTA";

export default function Home() {
  const siteUrl = "https://sugargoosheet.fit";

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryDropdown />
        <CategoryGrid />
        <ArticleCards />
        <ContentSections />
        <ArticleCTA />
      </main>
      <Footer />

      {/* WebSite Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Sugargoo Sheet",
            "url": siteUrl,
            "description": "The most complete Sugargoo Spreadsheet resource center. Discover products, reviews, shipping guides and shopping strategies.",
            "potentialAction": {
              "@type": "SearchAction",
              "target": `${siteUrl}/search?q={search_term_string}`,
              "query-input": "required name=search_term_string"
            }
          })
        }}
      />

      {/* Organization Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Sugargoo Sheet",
            "url": siteUrl,
            "description": "Independent resource website providing Sugargoo Spreadsheet guides, product reviews, shipping cost analysis, and shopping strategies.",
            "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg",
            "sameAs": [
              "https://kaspreadsheet.com"
            ]
          })
        }}
      />
    </>
  );
}